import { render, staticRenderFns } from "./PracticeCard.vue?vue&type=template&id=37b6eee5"
import script from "./PracticeCard.vue?vue&type=script&lang=js"
export * from "./PracticeCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports